(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-infinite-scroll"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('collection-infinite-scroll')) {
    // Fetches on a warm cache or a local dev server can resolve in a few milliseconds, which makes
    // the loading state flash without the shopper ever registering it. Hold it visible for at least
    // this long so a click always reads as "loading", not just a jump cut.
    const MIN_LOADING_VISIBLE_MS = 600;
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    class CollectionInfiniteScroll extends HTMLElement {
      connectedCallback() {
        this.nextUrl = this.getAttribute('next-url') || null;
        this.sectionId = this.getAttribute('section-id');
        this.loadingLabel = this.getAttribute('loading-text') || '';
        this.loading = false;
        this.abortController = null;

        const ownStatusEl = this.querySelector('[data-infinite-scroll-status]');
        this.announcer = this.querySelector('[data-infinite-scroll-announcer]');
        this.statusEls = Array.from(this.closest('.collection')?.querySelectorAll('[data-infinite-scroll-status]') || []);
        if (ownStatusEl) {
          this.setStatus(ownStatusEl.textContent);
        }

        this.button = this.querySelector('[data-infinite-scroll-load-more]');
        if (this.button) {
          this.buttonTextEl = this.button.querySelector('[data-infinite-scroll-load-more-text]');
          this.loadMoreLabel = this.buttonTextEl?.textContent.trim() || '';
          this.onButtonClick = this.onButtonClick.bind(this);
          this.button.addEventListener('click', this.onButtonClick);
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      onButtonClick(event) {
        event.preventDefault();
        this.loadNextPage();
      }

      setStatus(text) {
        this.statusEls.forEach((el) => { el.textContent = text; });
      }

      setLoading(isLoading) {
        this.loading = isLoading;

        if (this.button) {
          this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
          this.button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
          if (this.buttonTextEl) {
            this.buttonTextEl.textContent = isLoading ? this.loadingLabel : this.loadMoreLabel;
          }
        }

        if (isLoading && this.announcer) this.announcer.textContent = this.loadingLabel;
      }

      setNextUrl(url) {
        this.nextUrl = url;

        if (url) {
          this.setAttribute('next-url', url);
          this.button?.setAttribute('href', url);
        } else {
          this.removeAttribute('next-url');
          // No more pages to load: the button has nothing left to trigger, so drop it rather than
          // leave a disabled control sitting under the final count.
          this.button?.remove();
          this.button = null;
        }
      }

      appendProducts(productList, newProductList) {
        const appended = [];

        Array.from(newProductList.children).forEach((child) => {
          const node = document.importNode(child, true);
          // The theme only sets `reveal-on-scroll` when the "stagger products" setting is on, and its
          // reveal animation has already run for this list. Drop it so appended products animate once,
          // through the CSS animation below, whatever the setting is.
          node.removeAttribute('reveal-on-scroll');
          node.querySelectorAll('[reveal-on-scroll]').forEach((el) => el.removeAttribute('reveal-on-scroll'));
          node.setAttribute('infinite-scroll-appended', '');
          node.style.setProperty('--infinite-scroll-index', appended.length);
          productList.appendChild(node);
          appended.push(node);
        });

        // Keep the attribute only for the duration of the animation, so a card that is later moved or
        // re-rendered (layout switcher, quick view) doesn't replay it.
        appended.forEach((node) => {
          node.addEventListener('animationend', () => {
            node.removeAttribute('infinite-scroll-appended');
            node.style.removeProperty('--infinite-scroll-index');
          }, { once: true });
        });

        return appended;
      }

      async loadNextPage() {
        const productList = this.closest('.collection')?.querySelector('product-list');
        if (this.loading || !this.nextUrl || !productList) return;

        const requestedUrl = this.nextUrl;
        this.setLoading(true);
        this.abortController = new AbortController();
        const loadStartedAt = Date.now();

        try {
          const url = new URL(requestedUrl, window.location.origin);
          url.searchParams.set('section_id', this.sectionId);

          const response = await fetch(url.toString(), { signal: this.abortController.signal });
          if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

          const html = await response.text();
          const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
          const newSection = parsedDoc.querySelector('.shopify-section');
          const newProductList = newSection?.querySelector('product-list');
          const newTrigger = newSection?.querySelector('collection-infinite-scroll');

          // Keep the spinner and "loading more products" text on screen for a minimum stretch of
          // time before the new batch appears, so a fast response doesn't skip past it unseen.
          const remainingVisibleMs = MIN_LOADING_VISIBLE_MS - (Date.now() - loadStartedAt);
          if (remainingVisibleMs > 0) await wait(remainingVisibleMs);
          if (this.abortController.signal.aborted) return;

          if (newProductList) {
            this.appendProducts(productList, newProductList);
          }

          this.setNextUrl(newTrigger?.getAttribute('next-url') || null);

          const newStatus = newTrigger?.querySelector('[data-infinite-scroll-status]');
          if (newStatus) this.setStatus(newStatus.textContent);
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error('[collection-infinite-scroll] Failed to load next page', error);
            // Leave nextUrl untouched so the button, once re-enabled below, can be clicked again.
          }
        } finally {
          this.setLoading(false);
        }
      }
    }

    window.customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klaviyo-ga4-client-id"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'klaviyoGaClientIdSent';

    if (window.sessionStorage && window.sessionStorage.getItem(STORAGE_KEY)) {
      return;
    }

    function readGaClientId() {
      var match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
      if (!match) return null;

      // _ga cookie format: GA1.<domainDepth>.<idPart1>.<idPart2>
      var parts = decodeURIComponent(match[1]).split('.');
      if (parts.length < 4) return null;

      return parts[2] + '.' + parts[3];
    }

    function sendClientId(clientId) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['identify', { ga_client_id: clientId }]);

      if (window.sessionStorage) {
        window.sessionStorage.setItem(STORAGE_KEY, '1');
      }
    }

    var attempts = 0;
    var maxAttempts = 20;

    (function poll() {
      var clientId = readGaClientId();

      if (clientId) {
        sendClientId(clientId);
        return;
      }

      attempts += 1;
      if (attempts < maxAttempts) {
        setTimeout(poll, 300);
      }
    })();
  })();
  } catch(e) { console.error(e); }
})();

})();
